<template>
  <div class="app-drawer" :class="{ 'is-open': isOpen }">
    <div class="app-drawer__main" :class="{ 'is-open': isOpen }">
      <div class="fixed z-20 top-2 right-1 md:right-3">
        <button class="p-3 text-sky-600" @click="closeDrawer()">
          <AtomIcon name="circle-xmark" class="text-2xl" />
          <!-- <div class="text-xs">{{ $t('shared.close') }}</div> -->
        </button>
      </div>
      <div class="app-drawer__scrollable" ref="drawerScrollable">
        <div class="py-6 sticky z-10 top-0 bg-white">
          <!-- <div class="font-heading font-bold text-2xl">
            {{ $t('shared.domain') }}
          </div> -->
          <NuxtLink class="block" to="/" @click="closeDrawer()">
            <img class="h-5" src="~/assets/images/fans48-logo.svg">
          </NuxtLink>
        </div>
        <div class="app-drawer__content">
          <div class="space-y-8" v-auto-animate>
            <div class="border rounded-md">
              <NuxtLink :to="{ name: 'index' }" @click="closeDrawer()" class="block px-3 py-3">
                <div class="flex gap-2">
                  <div class="w-6 flex items-center justify-center text-sky-600">
                    <AtomIcon name="home-blank" class="text-lg" />
                  </div>
                  <div class="font-bold">
                    {{ $t('shared.nav.start') }}
                  </div>
                </div>
              </NuxtLink>
              <NuxtLink :to="{ name: 'leagues' }" @click="closeDrawer()" class="block px-3 py-3 border-t">
                <div class="flex gap-2">
                  <div class="w-6 flex items-center justify-center text-sky-600">
                    <AtomIcon name="list" class="text-lg" />
                  </div>
                  <div class="font-bold">
                    {{ $t('shared.nav.leagues') }}
                  </div>
                </div>
              </NuxtLink>
              <NuxtLink :to="{ name: 'teams' }" @click="closeDrawer()" class="block px-3 py-3 border-t">
                <div class="flex gap-2">
                  <div class="w-6 flex items-center justify-center text-sky-600">
                    <AtomIcon name="shirt-jersey" class="text-lg" />
                  </div>
                  <div class="font-bold">
                    {{ $t('shared.nav.teams') }}
                  </div>
                </div>
              </NuxtLink>
              <NuxtLink :to="{ name: 'games' }" @click="closeDrawer()" class="block px-3 py-3 border-t">
                <div class="flex gap-2">
                  <div class="w-6 flex items-center justify-center text-sky-600">
                    <AtomIcon name="calendar" class="text-lg" />
                  </div>
                  <div class="font-bold">
                    {{ $t('shared.nav.games') }}
                  </div>
                </div>
              </NuxtLink>
            </div>
            <AppDrawerFavorites />
            <AppDrawerLeagues />
            <!-- <AppDrawerHistory /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="app-drawer__backdrop" :class="{ 'is-open': isOpen }" @click="toggleDrawer()"></div>
  </div>
</template>

<script setup>
const app = useAppStore()
const drawerScrollable = ref(null)
const { isOpen, toggleDrawer, closeDrawer } = useAppDrawer()

// Watch route query to toggle app scroll lock
watch(() => isOpen.value, () => {
  app.lockScroll = isOpen.value

  if (isOpen.value && drawerScrollable.value) {
    requestAnimationFrame(() => {
      drawerScrollable.value.scrollTop = 0
    })
  }
})
</script>

<style scoped>
.app-drawer {
  @apply fixed z-50 inset-0 opacity-0 pointer-events-none transition-all duration-300 delay-300;
}

.app-drawer.is-open {
  @apply opacity-100 pointer-events-auto delay-0;
}

.app-drawer.is-open .app-drawer__main {
  @apply translate-x-0;
}
.app-drawer.is-open .app-drawer__backdrop {
  @apply bg-black/40;
}

.app-drawer__main {
  @apply bg-white;
  @apply w-full max-w-md;
  @apply fixed z-20 top-0 right-0 bottom-0;
  @apply translate-x-full transition-all duration-300;
}

.app-drawer__scrollable {
  @apply px-4 md:px-6 pb-8;
  @apply flex flex-col justify-start h-full;
  @apply overflow-y-scroll;
  -webkit-overflow-scrolling: touch;
}

.app-drawer__backdrop {
  @apply fixed z-10 inset-0 backdrop-blur-sm bg-black/0 transition-all duration-300;
}
</style>